import * as React from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import {Typography} from '@mui/material'
import {CatalogueDetailsInterface, ImageInterface} from '../Pages/catalogues/Catalogue.types'

export default function FormDialog({
  open,
  handleSend,
  handleClose,
  purchaseCatalogue,
  purchaseImage,
  isImage
}) {
  console.log('purchaseImage')
  console.log(purchaseImage.thumbnail)
  console.log(purchaseCatalogue.cover_image_front)

  return (
    <div>
      <Dialog open={open}>
        <DialogTitle>{isImage ? 'Inquire Canvas' : 'Inquire Catalogue'}</DialogTitle>
        <DialogContent>
          <div style={{}} className="d-flex ">
            <img
              style={{height: 100, width: 'auto', paddingRight: '10px'}}
              src={
                isImage
                  ? purchaseImage.thumbnail
                  : require(`../Assets/catalogues/${purchaseCatalogue.cover_image_front}`)
              }
              alt="First slide"
            />
            <div className="col">
              <Typography>
                {isImage
                  ? purchaseImage.title
                    ? purchaseImage.title
                    : 'unnamed'
                  : purchaseCatalogue.title}
              </Typography>
              <Typography>
                Price:
                {isImage
                  ? ' --'
                  : `${purchaseCatalogue.catalogue_price}€ (shipment costs are not
                included)`}
              </Typography>
              <Typography>Pusblishing year: {purchaseCatalogue.publishing_year}</Typography>
            </div>
          </div>

          {/* <DialogContentText>
            To subscribe to this website, please enter your email address here. We will send updates
            occasionally.
          </DialogContentText> */}

          <TextField
            sx={{marginRight: 5}}
            autoFocus
            margin="dense"
            id="name"
            label="Name"
            type="text"
            variant="standard"
          />
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Phone"
            type="tel"
            variant="standard"
          />

          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Email Address"
            type="email"
            fullWidth
            variant="standard"
          />

          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Message"
            type="text"
            fullWidth
            variant="standard"
          />
          <DialogContentText sx={{color: 'black', marginTop: 2}}>
            Once we have received the inquiry request, we will contact you. Sending a inquiries is
            not binding to any purchase. We will process the personal data you have supplied in
            accordance with our privacy policy.
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            style={{
              backgroundColor: 'rgba(82,130,48,1)',
              color: 'white'
            }}
            onClick={handleSend}
          >
            Send inquiry
          </Button>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
